import React, { useEffect, useState, useCallback } from 'react'
import AppSidebar from '../../components/AppSidebar'
import AppHeader from '../../components/AppHeader'
import PageHeader from '../../components/PageHeader'
import Filters from '../../components/Filters'
import ListActiveOrder from './ListActiveOrder'
import ListExpiredOrder from './ListExpiredOrder'
import CustomersService from '../../services/CustomersService'
import { PageLimit, DebounceDelay } from '../../utils/ConstantUtils'
import UseDebounce from '../../hooks/UseDebounce'
import { toast, ToastContainer } from 'react-toastify'
import Pagination from '../../components/Pagination'
import CreateUpdateProductModal from '../customers/components/modals/CreateUpdateProductModal'
import { useForm } from 'react-hook-form';
import ProductService from '../../services/ProductService'


const ListRenewal = () => {
  const { register, handleSubmit, setValue, formState: { errors }, control, reset } = useForm();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const pageLimit = PageLimit;
  const [itemsPerPage, setPageLimit] = useState(pageLimit);
  const offset = (currentPage - 1) * itemsPerPage;
  // const [appliedFilters, setAppliedFilters] = useState({});
  const debouncedSearchTerm = UseDebounce(searchTerm, DebounceDelay || 100);
  const [activeTab, setActiveTab] = useState('active');
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [showEditModal, setShowEditModal] = useState(false);
  const [productList, setProductList] = useState([]);
  const [customerProductData, setCustomerProductData] = useState({});
  const [customerId, setCustomerId] = useState('');


  const fetchAllProducts = useCallback(async () => {
    setLoading(true)
    try {
      const response = await CustomersService.getAll({
        products: activeTab,
        page: currentPage,
        limit: itemsPerPage,
        search: debouncedSearchTerm,
        offset: offset,
        // filters: appliedFilters,
      })
      if (response.status === 200) {
        setLoading(false);
        setProducts(response?.data?.data?.customerProducts);
        setTotalPages(response?.data?.data?.totalPages);
        setCurrentPage(response?.data?.data?.currentPage);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error in fetching all customers products", error);
    }
  }, [currentPage, itemsPerPage, debouncedSearchTerm, offset, activeTab])

  useEffect(() => {
    fetchAllProducts()
  }, [fetchAllProducts])
  const handleSearchChange = async e => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  }
  const handleItemsPerPageChange = async (e) => {
    setCurrentPage(1);
    setPageLimit(e.target.value);
  }
  const handleFilterSubmit = async () => {
    console.log('handleFilterSubmit');

  }
  const handleEditOrder = async (id, customerId) => {
    fetCustomerProductById(id);
    fetchProductList();
    setShowEditModal(true);
    setCustomerId(customerId);

  }
  const fetchProductList = async () => {
    try {
      const response = await ProductService.list();
      if (response.status === 200) {
        setProductList(response?.data?.data);
      }
    } catch (error) {
      console.error("Error in fetching all customers products", error);
    }
  }
  const fetCustomerProductById = async (id) => {
    try {
      const response = await CustomersService.getProducts(id);
      if (response.status === 200) {
        setCustomerProductData(response?.data?.data);
      }
    } catch (error) {
      console.error("Error in fetching all customers products", error);
    }
  }
  const sendEmail = async (id, type) => {
    try {
      const response = await CustomersService.sendEmail({ id, type: type });
      if (response.status === 200) {
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message || 'Failed to send email.');
      }
      return true
    } catch (error) {
      console.error("Error in sending email", error);
      toast.error(error?.response?.data?.message || error?.message || 'Error in sending email');
    }
  }

  const onSubmit = async (data, id = '') => {
    try {
      if (id) {
        data.customer_id = customerId;
        const response = await CustomersService.updateProducts(id, { data });

        if (response.status === 200) {
          toast.success(response.data.message);
          setProducts(prev =>
            prev.map(item => item.id === id ? response.data.data : item)
          );
        }
      } else {
        const response = await CustomersService.createProducts({ data });

        if (response.status === 201) {
          toast.success(response.data.message);
          setProducts(prev => [...prev, response.data.data]);
        }
      }

      return true;
    } catch (error) {
      console.error("Error in updating product", error);
      toast.error(
        error?.response?.data?.message || error?.message || 'Error in updating product'
      );
      return false;
    }
  };

  const filterFields = [
    { name: 'customer_id', placeholder: 'Customer', Dropdown: "yes" },
    { name: 'product_id', placeholder: 'Product', Dropdown: "yes" },
    { name: 'type', placeholder: 'Type', Dropdown: "yes" },
    { name: 'quantity', placeholder: 'Quantity', Dropdown: "no" },
    { name: 'status', placeholder: 'Status', Dropdown: "yes" },
    { name: 'start_date', placeholder: 'Start Date', Dropdown: "no" },
    { name: 'expiry_date', placeholder: 'Expiry Date', Dropdown: "no" },
    { name: 'invoice_no', placeholder: 'Invoice No', Dropdown: "no" },
  ];
  return (
    <>
      <AppSidebar />
      <div className="main-content">
        <AppHeader title='Renewal' />
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12">
              <PageHeader
                title={"Renewal"}
              />
              <div className="tab-content">
                <div className="tab-pane fade show active" id="contactsListPane" role="tabpanel" aria-labelledby="contactsListTab">
                  <div className="card">
                    <div className="card-header">
                      <div className="row align-items-center">
                        <div className="col">
                          <form>
                            <div className="input-group input-group-flush input-group-merge input-group-reverse">
                              <input
                                className="form-control list-search"
                                type="search"
                                placeholder="Search"
                                value={searchTerm}
                                onChange={handleSearchChange}
                              />
                              <span className="input-group-text">
                                <i className="fe fe-search" />
                              </span>
                            </div>
                          </form>
                        </div>
                        <div className="col-auto me-n3">
                          <form>
                            <select
                              className="form-select form-select-sm form-control-flush"
                              value={itemsPerPage}
                              onChange={handleItemsPerPageChange}
                            >
                              <option value="20">20 per page</option>
                              <option value="40">40 per page</option>
                              <option value="60">60 per page</option>
                              <option value="100">100 per page</option>

                            </select>
                          </form>
                        </div>
                        <div className="col-auto">
                          <Filters filterFields={filterFields} onApplyFilters={handleFilterSubmit} getFilterService={CustomersService.getTasksFilter} />
                        </div>
                      </div>
                    </div>
                    <div className="card-header">
                      <div className="row align-items-center">
                        <div className="col">
                          <ul className="nav nav-tabs nav-tabs-sm nav-justified card-header-tabs">
                            <li className="nav-item">
                              <button
                                className={`nav-link ${activeTab === 'active' ? 'active text-primary' : ''}`}
                                onClick={() => {
                                  setActiveTab('active');
                                  setCurrentPage(1); // Reset page on tab switch
                                }}
                              >
                                Active Orders
                              </button>
                            </li>
                            <li className="nav-item">
                              <button
                                className={`nav-link ${activeTab === 'expired' ? 'active text-primary' : ''}`}
                                onClick={() => {
                                  setActiveTab('expired');
                                  setCurrentPage(1); // Reset page on tab switch
                                }}
                              >
                                Expired Orders
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                      {activeTab === 'active' &&
                        <ListActiveOrder
                          products={products}
                          sendEmail={sendEmail}
                          handleEditOrder={handleEditOrder}
                          loading={loading}
                          offset={offset}

                        />

                      }
                      {activeTab === 'expired' &&
                        <ListExpiredOrder
                          products={products}
                          sendEmail={sendEmail}
                          loading={loading}
                          onSubmit={onSubmit}
                          offset={offset}
                        />

                      }
                    </div>
                    <Pagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer containerId={"toast-container"} />
      </div>
      {showEditModal && (
        <CreateUpdateProductModal
          show={showEditModal}
          handleClose={() => setShowEditModal(false)}
          register={register}
          handleSubmit={handleSubmit}
          setValue={setValue}
          onSubmit={onSubmit}
          errors={errors}
          control={control}
          reset={reset}
          productList={productList}
          initialValues={customerProductData}
        />
      )}
    </>
  )
}

export default ListRenewal